import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail } from "lucide-react";
import { api } from "@/lib/api";

export const Footer = () => {
  const [footerPages, setFooterPages] = useState({ policies: [], help: [], brand: [] });

  useEffect(() => {
    async function loadFooterPages() {
      try {
        const res = await api.get("/pages/footer");
        setFooterPages(res.data);
      } catch (err) {
        console.error("Failed to load footer pages:", err);
      }
    }
    loadFooterPages();
  }, []);

  // Build dynamic policy links
  const policyLinks = footerPages.policies.map((p) => [p.title, `/policies/${p.slug}`]);
  
  // Static help links + FAQs
  const helpLinks = [
    ["My Account", "/account"],
    ["Wishlist", "/wishlist"],
    ["Cart", "/cart"],
    ["FAQs", "/faqs"],
    ...footerPages.help.map((p) => [p.title, `/policies/${p.slug}`]),
  ];
  
  // Brand links (static + dynamic)
  const brandLinks = [
    ["Our Story", "/"],
    ...footerPages.brand.map((p) => [p.title, `/policies/${p.slug}`]),
  ];

  return (
    <footer className="bg-foreground text-[hsl(var(--ivory))]">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-1">
          <div className="font-logo text-2xl tracking-[0.18em]">BODYCRUSH</div>
          <p className="text-[10px] uppercase tracking-luxe opacity-60 mt-1">by Gujarish · Smart Intimates</p>
          <p className="text-sm opacity-70 mt-5 leading-relaxed font-light max-w-xs">
            Perfect Fit. Perfect Coverage. Perfectly Soft. Thoughtfully made intimate wear for women & kids.
          </p>
          <div className="flex gap-4 mt-6">
            <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="opacity-70 hover:opacity-100 transition-opacity">
              <Instagram className="w-5 h-5" strokeWidth={1.4} />
            </a>
            <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="opacity-70 hover:opacity-100 transition-opacity">
              <Facebook className="w-5 h-5" strokeWidth={1.4} />
            </a>
            <a href="mailto:hello@gujarish.com" aria-label="Email" className="opacity-70 hover:opacity-100 transition-opacity">
              <Mail className="w-5 h-5" strokeWidth={1.4} />
            </a>
          </div>
        </div>
        <FooterCol title="Shop" items={[["All Products", "/shop"], ["Panties", "/shop?category=Panties"], ["Camisoles", "/shop?category=Camisoles"], ["Kids", "/shop?audience=Kids"]]} />
        <FooterCol title="Help" items={helpLinks} />
        <FooterCol title="Policies" items={policyLinks.length > 0 ? policyLinks : [["Contact", "/policies/contact-information"], ["Shipping", "/policies/shipping-policy"], ["Returns", "/policies/return-exchange-policy"]]} />
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 sm:px-10 py-5 text-center text-xs opacity-60 tracking-wide">
          © {new Date().getFullYear()} BODYCRUSH™ by Gujarish. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

const FooterCol = ({ title, items }) => (
  <div>
    <h4 className="text-[11px] uppercase tracking-[0.2em] opacity-90 mb-5">{title}</h4>
    <ul className="space-y-3">
      {items.map(([label, to]) => (
        <li key={label}>
          <Link to={to} className="text-sm opacity-70 hover:opacity-100 font-light transition-opacity bc-underline">{label}</Link>
        </li>
      ))}
    </ul>
  </div>
);
